import { render, staticRenderFns } from "./Whatsapp.vue?vue&type=template&id=13313a0a&"
import script from "./Whatsapp.vue?vue&type=script&setup=true&lang=js&"
export * from "./Whatsapp.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports